import { CreateResponsiveStyle, DEVICE_SIZES, maxSize, } from "rn-responsive-styles";


const useStyles = CreateResponsiveStyle(
  {
    container: {
      width: "90%",
      marginLeft: 20,
      paddingRight: 20,
    },
    desktopView: {
      display: "flex"
    },
    dashboard_headerCards: {
      flexDirection: "row",
      marginHorizontal: -10,
      marginBottom: 30,
    },
    dashboard_headerCards_layoutBoxes: {
      width: "33.33333333%",
    },
    dashboard_headerCards_layoutBoxes1: {
      display: "flex",
      width: "33.33333333%",
    },
    dashboard_headerCards_layoutBoxes2: {
      display: "none",
      width: "33.33333333%",
    },
    dashboard_headerCards_layoutBoxesQL: {
      display: "none",
    },
    maroonCardContent: {
      justifyContent: "space-between",
    },
    maroonCardIcon: {
      height: "100%",
    },
    maroonCardIcon1: {
      height: "100%",
      display: "flex"
    },
    maroonCardIconMobile1: {
      height: "100%",
      display: "none"
    },

    dashboard_advertisement: {
      display: "none",
      marginLeft: 20,
    },
    mobileAddVehicle: {
      display: "none"
    },
    mobileBanner: {
      width: "100%",
      height: 123,
      borderRadius: 13,
      resizeMode: "contain",
      display: "none",
    },
    tabBanner: {
      width: "100%",
      height: 179,
      borderRadius: 13,
      resizeMode: "contain",
      display: "none",
    },
    mobileRechargeViewStyle: {
      display: "none",
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "center"
    },
    maroonCardStyle: {
      height: 122.9,
      flexGrow: 1,
      marginHorizontal: 10,
      flexDirection: "row",
      justifyContent: "space-between",
      alignItems: "center",

      backgroundColor: "#c32b2c",
      borderRadius: 15,
      paddingHorizontal: 20,
    },
    iconWidget: { flexDirection: "row", alignItems: "center", justifyContent: "center" },
    npciImageStyle: {
      width: 200.6,
      height: 45.1,
      marginTop: 20,
    },
    textStyle: {
      fontFamily: "Inter",
      fontSize: 15,
      fontWeight: "normal",
      fontStyle: "normal",
      lineHeight: 17,
      letterSpacing: 0.45,
      color: "#ffffff",
    },
    cardTextStyle: {
      fontFamily: "Inter",
      fontSize: 28,
      fontWeight: "100",
      fontStyle: "normal",
      lineHeight: 19,
      letterSpacing: 0,
      textAlign: "left",
      color: "#ffffff",
      flexWrap: "wrap",
      alignSelf: "flex-start",
      position: "relative",
      top: -10,
      paddingTop: 10,
    },
    cardVrnTextStyle: {
      fontFamily: "Inter",
      fontSize: 18,
      fontWeight: "light",
      fontStyle: "normal",
      lineHeight: 19,
      letterSpacing: 0,
      textAlign: "left",
      color: "#ffffff",
      flexWrap: "wrap",
      alignSelf: "flex-start",
      position: "relative",
      top: -10,
      paddingTop: 10,
    },
    tabViewQuickLinksStyle: {
      alignItems: "center",
      display: "none",
    },
    tabViewQuickLinks_TextContainer: {
      display: "none",
    },

    quicklinkIconViewStyle: {
      alignSelf: "center",
    },
    quicklinksIconStyle: {
      height: 22,
      width: 17,
      resizeMode: "center",
      alignSelf: "flex-end",
      position: "relative",
    },

    cardTextStyle1: {
      fontFamily: "Inter",
      fontSize: 13,
      fontWeight: "normal",
      fontStyle: "normal",
      lineHeight: 16,
      letterSpacing: 0.65,
      textAlign: "left",
      color: "#ffffff",
      position: "relative",
      paddingTop: 9,
    },
    dashboardmaroonCardContent: {
      flexDirection: "row",
      marginHorizontal: -10,
      marginBottom: 20,
      justifyContent: "space-between",
    },
    iconStyle: {
      width: 50,
      height: 40,
      resizeMode: "center",
      flex: 1,
    },

    userDetailsViewStyle: {
      display: "flex",
      marginBottom: 5,
    },
    bannerViewStyle: { display: "flex" },
    box: {
      width: 90,
      height: 90,
      backgroundColor: '#5AD2F4'
    }
  },

  {
    [DEVICE_SIZES.LG]: {
      maroonCardStyle: {
        maxWidth: 330,
      },
    },

    [DEVICE_SIZES.MD]: {
      dashboard_headerCards: {
        flexWrap: "wrap",
        height: 260,
        alignItems: "center",
        marginVertical: -10,
      },
      dashboard_headerCards_layoutBoxes: {
        width: "50%",
        marginVertical: 10,
      },
      dashboard_headerCards_layoutBoxesQL: {
        display: "flex",
        width: "50%",
        marginVertical: 10,
      },
      maroonCardStyle: {
        height: 114,
      },

      cardVrnTextStyle: {
        fontSize: 18,
      },

      cardTextStyle1: {
        fontSize: 13,
      },

      iconStyle: {
        width: 40,
        height: 30,
      },

      tabViewQuickLinksStyle: {
        display: "flex",
        flexDirection: "row",
        height: 114,
        marginHorizontal: 20,
        justifyContent: "space-around",
      },

      tabViewQuickLinks_TextContainer: {
        display: "flex",
        height: "100%",
        justifyContent: "space-evenly",
      },

      userDetailsViewStyle: {
        display: "none",
      },
      cardTextStyle: {
        fontFamily: "Inter",
        fontSize: 25,
      },
      dashboardmaroonCardContent: {
        flexDirection: "column",
      },
      bannerViewStyle: { display: "none" },
      dashboard_advertisement: {
        display: "flex",
      },
      tabBanner: {
        display: "flex",
      },
    },

    [maxSize(DEVICE_SIZES.SM)]: {
      dashboard_headerCards_layoutBoxes: {
        width: "100%",
      },
    },

    [DEVICE_SIZES.SM]: {
      dashboard_headerCards: {
        flexDirection: "column",
        alignItems: "flex-start",
      },
      maroonCardStyle: {
        width: "100%",
        height: 76,
        minWidth: 218,
        marginVertical: 3,
      },
      userDetailsViewStyle: {
        display: "none",
      },
      container: {
        marginLeft: 0,
        paddingLeft: 2,
      },
      dashboardmaroonCardContent: {
        flexDirection: "column",
      },
      cardTextStyle: {
        fontFamily: "Inter",
        fontSize: 20,
      },
      cardVrnTextStyle: {
        fontSize: 14,
      },
      cardTextStyle1: {
        fontSize: 9,
      },
      iconStyle: {
        width: 37,
        height: 28,
        resizeMode: "center",
        flex: 1,
      },
      bannerViewStyle: { display: "none" },
      mobileAddVehicle: {
        display: "flex"
      },
      desktopView: {
        display: "none"
      },
    },
    [DEVICE_SIZES.XS]: {
      dashboard_headerCards: {
        flexDirection: "column",
        alignItems: "flex-start",
      },
      maroonCardStyle: {
        width: "100%",
        height: 76,
        minWidth: 218,
        marginVertical: 3,
      },
      mobileRechargeViewStyle: {
        display: "flex",
        marginLeft: 10
      },
      dashboard_headerCards_layoutBoxes1: {
        display: "none"
      },
      dashboard_headerCards_layoutBoxes2: {
        display: "flex",
        width: "100%"
      },
      maroonCardIcon1: {
        height: "100%",
        display: "none"
      },
      maroonCardIconMobile1: {
        height: "100%",
        display: "flex"
      },
      userDetailsViewStyle: {
        display: "none",
      },
      container: {
        marginLeft: 0,
        paddingLeft: 2,
      },
      dashboardmaroonCardContent: {
        flexDirection: "column",
      },
      cardTextStyle: {
        fontFamily: "Inter",
        fontSize: 15,
      },
      cardVrnTextStyle: {
        fontSize: 14,
      },
      cardTextStyle1: {
        fontSize: 9,
        paddingTop: 3
      },
      iconStyle: {
        width: 37,
        height: 28,
        resizeMode: "center",
        flex: 1,
      },
      bannerViewStyle: { display: "none" },
      dashboard_advertisement: {
        display: "flex",
      },
      mobileBanner: {
        display: "flex",
      },
      mobileAddVehicle: {
        display: "flex"
      },
      desktopView: {
        display: "none"
      },
    },
  }
);

export default useStyles;